import React, { useMemo, useState } from 'react';
import { sanitizeMessage } from '../../../utils';
import MarkdownWithKatex from './MarkdownWithKatex';
import { useStableCallback } from '../../../hooks';
import { Button } from '../../ui/button';
import { cn } from '../../ui/utils';

const MCQ_OPTION_REGEX = /<mcq-option>([\s\S]*?)<\/mcq-option>/g;

const SelectOptions = ({ message, selectMcqOption }) => {
  const [isOptionSelected, setIsOptionSelected] = useState(false);

  const options = useMemo(() => {
    const sanitized = sanitizeMessage(message);
    const matches = [...sanitized.matchAll(MCQ_OPTION_REGEX)];
    return matches.map((match) => match[1].trim()).filter(Boolean);
  }, [message]);

  const handleOptionSelect = useStableCallback((option) => {
    if (isOptionSelected) return;
    setIsOptionSelected(true);
    selectMcqOption(option);
  });

  if (!options.length) {
    return null;
  }

  return (
    <div className="mt-3 flex w-full flex-col gap-2">
      {options.map((option, index) => (
        <Button
          key={index}
          type="button"
          variant="default"
          size="sm"
          disabled={isOptionSelected}
          className={cn(
            'chat-mcq-option h-auto min-h-9 w-full justify-start whitespace-normal px-3 py-2 text-left text-sm font-medium',
            isOptionSelected && 'opacity-60'
          )}
          onClick={() => handleOptionSelect(option)}
        >
          <MarkdownWithKatex>{option}</MarkdownWithKatex>
        </Button>
      ))}
    </div>
  );
};

export default SelectOptions;
